import { render, staticRenderFns } from "./verifyWorkspace.vue?vue&type=template&id=5804448b&"
import script from "./verifyWorkspace.vue?vue&type=script&lang=js&"
export * from "./verifyWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5804448b')) {
      api.createRecord('5804448b', component.options)
    } else {
      api.reload('5804448b', component.options)
    }
    module.hot.accept("./verifyWorkspace.vue?vue&type=template&id=5804448b&", function () {
      api.rerender('5804448b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/verify/verifyWorkspace.vue"
export default component.exports